import globals from "./globals";

let {g_sessionList, g_doctor, g_timers, g_userList, getDoctorId, setDoctorId } = globals;
import {sendMessage, wrapup} from "./utils";
import {StreamVideoClient} from "@stream-io/video-client";
import {cleanupParticipant, renderParticipant} from "./participant";

let startCallHook = null;

const setPageTitle = (s) => {
    const pageTitleText = document.getElementById('txtPageTitle');
    pageTitleText.innerText = s;
}

const processSessions = (sessionList) => {
    //console.log('processSessions >>>', sessionList);
    sessionList.forEach( (item) => {
        let currentDoctor = getDoctorId();
        if (item.teleconsult_doctor && item.teleconsult_doctor !== currentDoctor) {
            //console.log(`skipping ${currentDoctor} ${item.teleconsult_doctor}`);
            return;
        }
        /*
        let pidJoin = g_userList.indexOf(item.name);
        if (pidJoin > -1) {
            g_userList.splice(pidJoin, 1);
            removeUserfromWaitingList(item.name);
        }
        if (['Checked In', 'Consulting'].includes(item.plato_queue_status)) {
            g_userList[g_userList.length] = item.name;
            addUserToWaitingList(item);
        }*/
        switch (item.plato_queue_status) {
            case 'Hold':
            case 'Checked In':
            case 'Consulting':
                let pidJoin = g_userList.indexOf(item.name);
                if (pidJoin === -1) {
                    g_userList[g_userList.length] = item.name;
                    //console.log("Insert ", item.name, "in array");
                    addUserToWaitingList(item);
                } else {
                    // console.log("CHECK IN ", item.name, "is already in the array");
                    updateUserStatusInWaitingList(item);
                }
                break;
            default:
                let pidPos = g_userList.indexOf(item.name);
                if (pidPos > -1) {
                    // console.log("REMOVE CHECK IN FROM ARRAY", item.name);
                    g_userList.splice(pidPos, 1);
                    removeUserfromWaitingList(item.name);
                }
                break;

        }
    } )

};

const removeUserfromWaitingList = (user) => {
    const buttonElement = document.getElementById(user);
    if (buttonElement!==null)
        buttonElement.remove();
};

const nullString = (s) => {
    if (s===null || s==='null') {
        return 'Not specified';
    }
    return s;
}

const sendTeleconsultMessage = async ()  => {
    const checkInNameText = document.getElementById('refCheckIn');
    const sendMessageText = document.getElementById('message');
    let message = sendMessageText.value;
    let checkin = checkInNameText.value;
    await sendMessage(checkin, message)
};

const showPatientDetails = (patientName, patientNric, symptoms, allergies, checkinName, patientId) =>{
    const sendMessageBtn = document.getElementById('send-message-btn');

    const allergiesText = document.getElementById('txtAllergies');
    const symptomsText = document.getElementById('txtSymptoms');
    const patientNricText = document.getElementById('txtPatientId');
    const patientNameText = document.getElementById('txtPatientName');
    const startTeleBtn = document.getElementById('btnStartTele');
    const patientDetails = document.getElementById('patient-details')
    const checkInNameRef = document.getElementById('refCheckIn');
    const patientRef = document.getElementById('refPatient');
    const doctorRef = document.getElementById('refDoctor');

    patientNameText.innerText = patientName;
    patientNricText.innerText = patientNric;
    symptomsText.innerText = nullString(symptoms);
    allergiesText.innerText = nullString(allergies);

    checkInNameRef.value = checkinName;
    patientRef.value = patientId;
    doctorRef.value = getDoctorId();
    // sendMessageBtn.addEventListener("click", () => sendTeleconsultMessage(checkinName));
    /*
    sendMessageBtn.setAttribute(
        "onclick",
        `sendTeleconsultMessage("${checkinName}")`
    );*/
    // startTeleBtn.setAttribute("name", checkinName);
    /*startTeleBtn.setAttribute(
        "onclick",
        "StartConference(this)"
    );*/
    //startTeleBtn.addEventListener("click", () => StartConference(checkinName, patientId, getDoctorId()),
    //    { once: true });
    $(patientDetails).removeClass('d-none');
}

const showTimer = (element, startTime) => {

    element.innerText = new Date(Date.now() - Date.parse(startTime)).toISOString().slice(11, 19);
};

const updateUserStatusInWaitingList = (checkin) => {
    const ele = document.getElementById(checkin.name);
    if (ele!==null) {
        const capsule = ele.querySelector('.rounded-pill');
        if (capsule!==null) {
            capsule.innerText = checkin.plato_queue_status;
        }
    } else {
        console.log(`unable to getElementById ${checkin.name}`);
    }
};


const addUserToWaitingList = (checkin) => {
    const container_listGroup = document.getElementById("usersonWaitList");

    const checkIdExists = document.getElementById(checkin.name);
    //console.log('addUserToWaitingList >>>', checkin);
    if (!checkIdExists) {
        try {
            let card = document.createElement("div");
            card.id = checkin.name;
            card.className = "card mb-1 card-rect";
            /*
            card.setAttribute(
                "onclick",
                `showPatientDetails('${checkin.patient_name}','${checkin.nric}','${checkin.check_in_reason.replace(/\n/,'')}','${checkin.drug_allergies}','${checkin.name}')`
            );*/
            card.addEventListener("click", () => {
                showPatientDetails(checkin.patient_name, checkin.nric, checkin.check_in_reason.replace(/\n/,''),
                    checkin.drug_allergies, checkin.name, checkin.check_in_patient);
            });


            let cardBody = document.createElement("div");
            cardBody.className = "card-body";

            let patientName = document.createElement("h6");
            patientName.className = "card-title";
            patientName.style.textAlign = "left";
            patientName.innerText = `${checkin.patient_name}`;

            let patientID = document.createElement("span");
            patientID.style.textAlign = "left";

            let maskedNric = checkin.nric || '';
            // Mask Singapore NRIC
            if(checkin.nric!==null && checkin.nric.match(/^[STFG]\d{7}[A-Z]$/)){
                maskedNric='X'.repeat(checkin.nric.length - 4) + checkin.nric.slice(5);
            }
            patientID.innerText = `Patient ID: ${maskedNric}`;

            let avatarImage = document.createElement("div");
            avatarImage.className = "rounded-circle border d-flex justify-content-center align-items-center";
            avatarImage.style = "width:48px;height:48px";

            let icon = document.createElement("i");
            icon.className = "fas fa-user-alt fa-2x text-info";
            avatarImage.appendChild(icon);

            let row = document.createElement("div");
            row.className = "row";

            let piccol = document.createElement('div');
            piccol.className = "col-2";
            piccol.appendChild(avatarImage);

            let leftcol = document.createElement('div');
            leftcol.className = "col-7";
            leftcol.style="display:flex; flex-direction:column";

            let rightcol = document.createElement('div');
            rightcol.className = "col-3";

            let d = document.createElement('div');
            d.className="float-end";
            d.style="display:flex; flex-direction:column";

            // console.log(checkin.modified);
            let timestart = document.createElement('small');
            timestart.style="text-align: right";
            // timestart.innerText = new Date(Date.now() - Date.parse(checkin.modified)).toISOString().slice(11, 19);
            let tid = setInterval(() => showTimer(timestart, checkin.modified), 1000);
            g_timers[checkin.name] = tid;
            d.appendChild(timestart);

            let capsule = document.createElement('span');
            capsule.className="badge rounded-pill bg-success";
            capsule.innerText = checkin.plato_queue_status;
            d.appendChild(capsule);

            rightcol.appendChild(d);


            const useronWaitbutton = document.createElement("button");
            useronWaitbutton.setAttribute("type", "button");
            useronWaitbutton.setAttribute("class", "btn btn-secondary m-1 ");
            useronWaitbutton.setAttribute("name", checkin.name);
            useronWaitbutton.setAttribute(
                "onclick",
                "StartConference(this)"
            );
            useronWaitbutton.innerHTML = "Start";

            leftcol.appendChild(patientName);
            leftcol.appendChild(patientID);
            //rightcol.appendChild(useronWaitbutton);

            // cardBody.appendChild(headingH5);
            row.appendChild(piccol);
            row.appendChild(leftcol);
            row.appendChild(rightcol);
            cardBody.appendChild(row)
            card.appendChild(cardBody);
            container_listGroup.appendChild(card);
        } catch (error) {
            console.log("addUserToWaitingList: " + error);
        }
    }
};

const findSession = (sessionId) => {
    for (let i=0; i<g_sessionList.length; i++) {
        console.log('session' + g_sessionList[i] + sessionId);
        if (g_sessionList[i].name === sessionId)
            return g_sessionList[i];
    }
    return null;
};

/* change tab, pass in the #id */
const changeTab = (tabName) => {

    var triggerEl = document.querySelector(`#nav-tab button[data-bs-target="${tabName}"]`)
    // console.log(triggerEl);
    triggerEl.click();
    //if (triggerEl!==null)
    //bootstrap.Tab.getInstance(triggerEl).show() // Select tab by name
};

const  StartConference = () => {

    let refCheckIn = document.getElementById('refCheckIn');
    let refPatient = document.getElementById('refPatient');
    let refDoctor = document.getElementById('refDoctor');
    console.log("StartConference -->", refCheckIn.value, refPatient.value, refDoctor.value);

    if (startCallHook) {
        console.log("calling startCallHook");
        startCallHook(refCheckIn.value, refPatient.value, refDoctor.value);
    }
    changeTab('#nav-call');
};

const setStartCallHook = (hook) => {
    startCallHook= hook;
}

const endCall = async () => {
    /*
    if (g_timers.hasOwnProperty(g_currentCheckin)) {
        console.log("remove timer");
        clearInterval(g_timers[g_currentCheckin]);
        delete g_timers[g_currentCheckin];
    }*/
    const patientDetails = document.getElementById('patient-details')
    $(patientDetails).addClass('d-none');

    let refCheckIn = document.getElementById('refCheckIn');
    await wrapup(refCheckIn.value, 2);  // Set to Processing RX

    changeTab('#nav-home'); // Skip the post call screen

    setPageTitle('Patient Waitlist');

}



export  { addUserToWaitingList, processSessions, removeUserfromWaitingList, setStartCallHook, endCall, sendTeleconsultMessage, StartConference};